/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import MuiDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

export default function PromptDialog({
  open,
  onClose,
  actions = [],
  title,
  label,
  defaultValue = '',
}) {
  const { t } = useTranslation();

  const [value, setValue] = useState(defaultValue);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const saveAction = actions.find(x => x.label === t('Spara'));

      if (saveAction) {
        saveAction.onClick(value);
      }
    }
  };

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      css={css`
        z-index: 4000;
      `}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          css={css`
            margin-top: 0.5rem;
          `}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress}
          label={label}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        {(actions || []).map((x, i) => (
          <Button
            key={i}
            onClick={() => {
              if (typeof x.onClick === 'function') {
                x.onClick(value);
              } else {
                onClose(value);
              }
            }}
          >
            {x.label}
          </Button>
        ))}
      </DialogActions>
    </MuiDialog>
  );
}
